"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var ProgressBar = function (_a) {
    var values = _a.values, outOf = _a.outOf, outerClassName = _a.outerClassName, outerStyle = _a.outerStyle, innerClassName = _a.innerClassName, innerStyle = _a.innerStyle;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)('height-100 width-100 flex-container rounded bg-white overflow-hidden flex-1', outerClassName), style: outerStyle }, values.map(function (value) {
            return (react_1.default.createElement("div", { key: value.color, style: __assign({ width: "".concat((value.value / outOf) * 100, "%"), backgroundColor: value.color, transition: 'width 100ms' }, innerStyle), className: (0, classnames_1.default)('shadow-none flex-container flex-dir-column text-center nowrap text-white align-center', innerClassName) }));
        }))));
};
exports.default = ProgressBar;
